import { green, orange, purple, red } from '@mui/material/colors';
import { Map } from 'immutable';
import moment from 'moment/moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { customerPlantsPath, siteGroupStructuresPath, sitePath } from '@sophocles/router/paths';

const RadioLocation = ({ radio }) => {
  const { t } = useTranslation();
  const finalRadio = radio.update(() => {
    let label = t('general.unknown');
    let siteName = null;
    let plantName = null;
    let customerName = null;
    let inventory = null;
    const timestamp = moment(radio.get('history_date'));
    const activationState = radio.getIn(['billing', 'activation_state_display']);
    const event = radio.get('event');
    // The customer ref always lives at location.customer — the site_group
    // ref is a bare { type, id, name, description } envelope with no
    // nested customer.
    const custId = radio.getIn(['location', 'customer', 'id']);
    const custName = radio.getIn(['location', 'customer', 'name']);
    const customerLabel = custId != null && custName != null ? custId + '. ' + custName : (custName ?? null);
    if (radio.getIn(['location', 'site'])) {
      const siteGroup = radio.getIn(['location', 'site_group'], Map());
      label = t('radio.onSite');
      customerName = customerLabel;
      plantName = siteGroup.get('name');
      siteName = radio.getIn(['location', 'site', 'name']);
    } else if (radio.getIn(['location', 'site_group'])) {
      const siteGroup = radio.getIn(['location', 'site_group'], Map());
      label = t('radio.plantInventory');
      customerName = customerLabel;
      plantName = siteGroup.get('name');
    } else if (radio.getIn(['location', 'customer'])) {
      label = t('radio.customerInventory');
      customerName = customerLabel;
    } else if (radio.getIn(['location', 'inventory_location'])) {
      label = t('radio.inventory');
      inventory = radio.getIn(['location', 'inventory_location', 'name']);
    }
    return radio.merge({
      label,
      siteName,
      customerName,
      plantName,
      inventory,
      activationState,
      event,
      timestamp,
    });
  });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            backgroundColor: finalRadio.get('siteName')
              ? green[500]
              : finalRadio.get('plantName') || finalRadio.get('customerName')
                ? orange[500]
                : finalRadio.get('inventory')
                  ? purple[500]
                  : 'black',
            borderRadius: 4,
            textAlign: 'center',
            padding: '0 6px 0 6px',
            marginRight: '4px',
            color: 'white',
            whiteSpace: 'nowrap',
          }}
        >
          {finalRadio.get('label')}
        </div>
        {radio.getIn(['location', 'deleted']) && (
          <div
            style={{
              backgroundColor: red[500],
              borderRadius: 4,
              textAlign: 'center',
              padding: '0 6px',
              color: 'white',
              whiteSpace: 'nowrap',
            }}
          >
            {t('general.deleted')}
          </div>
        )}
      </div>
      <div style={{ whiteSpace: 'nowrap' }}>
        <div>
          {finalRadio.get('inventory') ? (
            <div>{t('radio.inventoryLocation') + ': ' + finalRadio.get('inventory')}</div>
          ) : finalRadio.get('siteName') ? (
            <div>
              {t('general.customer') + ': '}
              <Link to={customerPlantsPath({ cust_id: finalRadio.getIn(['location', 'customer', 'id']) })}>
                {finalRadio.get('customerName')}
              </Link>
              <div>
                {t('general.plant') + ': '}
                <Link
                  to={siteGroupStructuresPath({
                    cust_id: finalRadio.getIn(['location', 'customer', 'id']),
                    sitegroup_id: finalRadio.getIn(['location', 'site_group', 'id']),
                  })}
                >
                  {finalRadio.get('plantName')}
                </Link>
              </div>
              <div>
                {t('general.site') + ': '}
                <Link
                  to={sitePath({
                    cust_id: finalRadio.getIn(['location', 'customer', 'id']),
                    sitegroup_id: finalRadio.getIn(['location', 'site_group', 'id']),
                    site_id: finalRadio.getIn(['location', 'site', 'id']),
                  })}
                >
                  {finalRadio.get('siteName')}
                </Link>
              </div>
            </div>
          ) : finalRadio.get('plantName') ? (
            <div>
              {t('general.customer') + ': '}
              <Link to={customerPlantsPath({ cust_id: finalRadio.getIn(['location', 'customer', 'id']) })}>
                {finalRadio.get('customerName')}
              </Link>
              <div>
                {t('general.plant') + ': '}
                <Link
                  to={siteGroupStructuresPath({
                    cust_id: finalRadio.getIn(['location', 'customer', 'id']),
                    sitegroup_id: finalRadio.getIn(['location', 'site_group', 'id']),
                  })}
                >
                  {finalRadio.get('plantName')}
                </Link>
              </div>
            </div>
          ) : finalRadio.get('customerName') ? (
            <div>
              {t('general.customer') + ': '}
              <Link to={customerPlantsPath({ cust_id: finalRadio.getIn(['location', 'customer', 'id']) })}>
                {finalRadio.get('customerName')}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default RadioLocation;
